'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _modules = require('redux/modules/modules');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module1Act1 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user, profile: state.profile.data,
    act: state.moduleData.data.module1.act1 };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module1Act1, _Component);

  function Module1Act1() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module1Act1);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module1Act1.__proto__ || (0, _getPrototypeOf2.default)(Module1Act1)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 1,
      appId: 1,
      title: 'Reducing non-core foods intake',
      isCompleted: _this.props.act.isCompleted || false,
      eatNonCore: _this.props.act.eatNonCore || '', // can you think of any non-core foods that <name> eats?
      nonCoreFood: _this.props.act.nonCoreFood || '', // do you have non core foods in the house
      childAware: _this.props.act.childAware || '', // is child aware of the foods in the house
      childKnow: _this.props.act.childKnow || '', // does the child know where these foods are usually stored
      childSee: _this.props.act.childSee || '' // are these foods in a place where child can see them?
    }, _this.handleComplete = function () {
      var obj = _this.state;
      obj.isCompleted = true;
      _this.setState(obj);

      _this.props.updateModuleAct(_this.props.user.userId, _this.state.moduleId, _this.state.appId, obj);

      _this.props.changeItem(_this.state.moduleId, 2, _this.state.appId + 1);
    }, _this.handleEat = function (event) {
      var obj = _this.state;
      obj.eatNonCore = event.target.value;
      _this.setState(obj);
    }, _this.handleNonCoreFood = function (event) {
      var obj = _this.state;
      obj.nonCoreFood = event.target.value;

      if (event.target.value === 'No') {
        obj.childAware = '';
        obj.childKnow = '';
        obj.childSee = '';
        //obj.isCompleted = false;
      }

      _this.setState(obj);
    }, _this.handleChildAware = function (event) {
      var obj = _this.state;
      obj.childAware = event.target.value;
      console.log('handle child aware');
      if (event.target.value === 'No') {
        obj.childKnow = '';
        obj.childSee = '';
      }

      _this.setState(obj);
    }, _this.handleChildKnow = function (event) {
      var obj = _this.state;
      obj.childKnow = event.target.value;
      console.log('handle child know');
      if (event.target.value === 'No') {
        obj.childSee = '';
      }

      _this.setState(obj);
    }, _this.handleChildSee = function (event) {
      var obj = _this.state;
      obj.childSee = event.target.value;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle when user finishes this module
   */


  /*
   * User clicks on Yes or No for
   * if they have non-core foods
   */


  /*
   * User clicks on Yes or No for
   * if they have non-core foods
   */


  /*
   * User clicks on Yes or No for if
   * their child knows where the non-core foods are
   */


  /*
   * User clicks on Yes or No for if
   * their child can see the non-core foods
   */


  (0, _createClass3.default)(Module1Act1, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 1'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            'h3',
            null,
            this.props.profile.childName,
            '\'s non-core foods'
          ),
          _react2.default.createElement(
            'h5',
            null,
            'Can you think of any non-core foods that ',
            this.props.profile.childName,
            ' eats?'
          ),
          _react2.default.createElement(
            ReactBootstrap.FormGroup,
            { onChange: this.handleEat },
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'eatnoncore', value: 'Yes', checked: this.state.eatNonCore === 'Yes' },
              'Yes'
            ),
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'eatnoncore', value: 'No', checked: this.state.eatNonCore === 'No' },
              'No'
            ),
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'eatnoncore', value: 'Do not know', checked: this.state.eatNonCore === 'Do not know' },
              'Don\'t know/not sure if it is non-core'
            )
          ),
          this.state.eatNonCore && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'One strategy for decreasing kids\' intake of non-core foods is to limit how much of these foods you have in the house and to store them somewhere that your children can\'t access or is hidden.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Although this is ideal, it\'s often difficult for families to do.'
            ),
            _react2.default.createElement(
              'h5',
              null,
              'Do you ever have \'non-core\' foods in the house?'
            ),
            _react2.default.createElement(
              ReactBootstrap.FormGroup,
              { onChange: this.handleNonCoreFood },
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'noncore', value: 'Yes', checked: this.state.nonCoreFood === 'Yes' },
                'Yes'
              ),
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'noncore', value: 'No', checked: this.state.nonCoreFood === 'No' },
                'No'
              )
            )
          ),
          this.state.nonCoreFood === 'No' && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h5',
              null,
              'That\'s really good! Is it hard to maintain? How have you achieved that?'
            ),
            _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete, complete: this.state.isCompleted })
          ),
          this.state.nonCoreFood === 'Yes' && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h5',
              null,
              'Is your child aware of these foods in the house?'
            ),
            _react2.default.createElement(
              ReactBootstrap.FormGroup,
              { onChange: this.handleChildAware },
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'childaware', value: 'Yes', checked: this.state.childAware === 'Yes' },
                'Yes'
              ),
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'childaware', value: 'No', checked: this.state.childAware === 'No' },
                'No'
              )
            )
          ),
          this.state.childAware === 'No' && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete, complete: this.state.isCompleted })
          ),
          this.state.childAware === 'Yes' && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h5',
              null,
              'Does he/she know where these foods are usually stored?'
            ),
            _react2.default.createElement(
              ReactBootstrap.FormGroup,
              { onChange: this.handleChildKnow },
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'childknow', value: 'Yes', checked: this.state.childKnow === 'Yes' },
                'Yes/Sometimes'
              ),
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'childknow', value: 'No', checked: this.state.childKnow === 'No' },
                'No'
              )
            )
          ),
          this.state.childKnow === 'Yes' && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h5',
              null,
              'Are these foods in a place where your child is able to see them? For example, on display or in a cupboard he/she can open?'
            ),
            _react2.default.createElement(
              ReactBootstrap.FormGroup,
              { onChange: this.handleChildSee },
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'childsee', value: 'Yes', checked: this.state.childSee === 'Yes' },
                'Yes'
              ),
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'childsee', value: 'No', checked: this.state.childSee === 'No' },
                'No'
              )
            )
          ),
          (this.state.childSee === 'No' || this.state.childKnow === 'No') && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete, complete: this.state.isCompleted })
          ),
          this.state.childSee === 'Yes' && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'It can be helpful to store these foods in a place that your child doesn\'t know about or to store them in containers that you can\'t see into.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'When you have time, let\'s try moving some of these foods to places that aren\'t visible to your child.'
            ),
            _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete })
          )
        )
      );
    }
  }]);
  return Module1Act1;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  profile: _propTypes2.default.object,
  act: _propTypes2.default.object,
  changeItem: _propTypes2.default.func,
  updateModuleAct: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = Module1Act1;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/1/Activities/Act1.js
// module id = 1160
// module chunks = 0